import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { environment } from '@env/environment';
import { HttpErrorNotifierService } from '@core/services/http-error-notifier/http-error-notifier-service';

/**
 * À poser sur une requête dont l'erreur est affichée autrement qu'en toast
 * (ex. `grid-load-error`) : `new HttpContext().set(SKIP_ERROR_TOAST, true)`.
 */
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

/**
 * Requêtes jamais signalées : Cizo (même exclusion que l'intercepteur axios du SDK),
 * Keycloak (renouvellement de jeton géré par angular-auth-oidc-client) et les assets
 * (fichiers i18n — une clé manquante vaut mieux qu'un toast au démarrage).
 */
function isExcluded(url: string): boolean {
  return (
    (!!environment.cizoUrl && url.includes(environment.cizoUrl)) ||
    (!!environment.KEYCLOAK_URL && url.includes(environment.KEYCLOAK_URL)) ||
    url.includes('assets/')
  );
}

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_ERROR_TOAST) || isExcluded(req.url)) {
    return next(req);
  }
  const notifier = inject(HttpErrorNotifierService);
  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        const detail = (error.error as Record<string, unknown> | null)?.['detail'];
        notifier.notify({
          status: error.status,
          detail: typeof detail === 'string' ? detail : undefined,
        });
      }
      return throwError(() => error);
    }),
  );
};
